<template>
    <div class="container-fluid-carousellarge">
        <div class="">
					<div>
						<div>
							<div>
								<swiper
									ref="swipper_vertical"
									class="uvnswipper"
									:slidesPerView="3"
									:spaceBetween="10"
									:initial-slide="1"
									:centered-slides-bounds="true"
									:centered-slides="true"
									:autoHeight="true"
									:breakpoints="breakpoints"
									:loop="true"
									:navigation="navigation"
									@swiper="onSwiper"
									>
									<swiper-slide v-for="(item, ix) in images" :key="`item_${ix}`">
										<div>
											<div class="wrapper-img-carousel">
												<img class="img-carousel" :src="item.path" alt="..." width="100%">
											</div>
											<div class="item-description">
												{{ item.description }}
											</div>
										</div>
									</swiper-slide>
									<div @click="nextSwipe()" class="swiper-next">
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
											<path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
										</svg>
									</div>
									<div @click="prevSwipe()" class="swiper-prev">
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
											<path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
										</svg>
									</div>
								</swiper>
									
							</div>
						</div>
					</div>
        </div>
    </div>
</template>

<style lang="scss">
	.container-fluid-carousellarge {
		position: relative;
		width: 100vw;
		left: calc((100vw - 100%) / 2 * -1);
		overflow: hidden;
    background: #000;
		margin: 35px 0;

		@media(max-width:560px){
			left: calc((100vw - 100%) / 2 * -1);
    	width: 100vw;
		}

		.swiper-prev, .swiper-next {
			background: #fffffff7;
			padding: 15px;
			border-radius: 50%;
			position: absolute;
			top: 50%;
			margin-top: calc(0px - (var(--swiper-navigation-size) / 2));
			z-index: 10;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;

			svg {
				fill: #f14036;
			}
		}

		.swiper-prev {
			left: 30vw;
			cursor: pointer;

			@media (max-width: 575.98px) {
				left: 0;
			}
		}

		.swiper-next  {
			right: 30vw;
			cursor: pointer;

			@media (max-width: 575.98px) {
				right: 0;
			}
		}

		.swiper-slide-prev {
			justify-content: start;
		}

		.swiper-slide-next {
			justify-content: end;
		}

		.item-description {
			display: none;
			font-size: 16px;
		}

		.swiper-slide {
			display: flex;
			align-items: center;
			justify-content: center;
			min-height: 720px;
			height: 80vh;
			text-align: center;

			@media (max-width: 575.98px) {
				min-height: 520px;
				height: 90vh !important;
			}

			.img-carousel {
				width: 65% !important;
				max-width: 420px;
				object-fit: cover;
				object-position: top;
				opacity: 0.5;
			}

			&.swiper-slide-active {
				.img-carousel {
					position: relative;
					width: 200% !important;
					max-width: 620px !important;
					height: 500px !important;
					opacity: 1;
					object-fit: contain !important;
					object-position: bottom;

					@media (max-width: 575.98px) {
						width: 80% !important;
						height: 55vh !important;
						object-fit: contain !important;
						object-position: center;
					}
				}

				.wrapper-img-carousel {
					position: relative;
					left: -17%;
					width: 135%;

					@media (max-width: 575.98px) {
						left: 0%;
						width: 100%;
					}
				}

				.item-description {
					display: block;
					font-size: 21px;
					padding: 15px 0;
					color: #fff;
					width: 90%;
					margin: 0 auto;
				}
			}
		}

		
	}
</style>

<script>
	import { Navigation, Pagination } from 'swiper'

	import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'

	// Import Swiper styles
  import 'swiper/swiper.scss'

	export default {
		name: 'CarouselVertical',
		components: {
      Swiper,
      SwiperSlide,
    },
		data() {
			return {
				navigation: { nextEl: '.swiper-button-prev', prevEl: '.swiper-button-next', },
				breakpoints: {
					1181: {
						slidesPerView: 3
					},
					1180: {
						slidesPerView: 3
					},
					1020: {
						slidesPerView: 1
					},
					700: {
						slidesPerView: 1
					},
					500: {
						slidesPerView: 1
					},
					300: {
						slidesPerView: 1
					}
				}
			}
		},
		computed: {
			images() {
				return require('@/data/carousellarge.json')
			}
		},
		methods: {
			nextSwipe() {
				window.swiper2.slideNext()
			},
			prevSwipe() {
				window.swiper2.slidePrev()
			}
		},
		setup() {
			const onSwiper = (swiper) => {
				window.swiper2 = swiper;
			}

			return {
				modules: [Navigation, Pagination],
				onSwiper,
			}
		},
	}
</script>